import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

interface IPayments {
  ALLOW_DEMO_ACCOUNTS: number;
  ENABLE_PAYMENT: number;
  ENABLE_CREDIT_CARD: number;
  ENABLE_CREDIT_CARD_WITHDRAW: number;
  ENABLE_BANK_CARD: number;
  ENABLE_BANK_CARD_WITHDRAW: number;
  ENABLE_WEB_TRADER: number | null;
  ENABLE_CRYPTO_PAY: number;
  PAYMENT_CURRENCY: string[];
  PAYMENT_CURRENCY_KASHA: string[];
  PAYMENT_GATEWAYS: { value: string; label: string }[];
  TRANSLATE: Record<string, string>;
  CRYPTO: Record<string, string[]>;
  // captcha
  ENABLE_RECAPTCHA: 1 | 0;
  RECAPTCHA_KEY: string;

  WEBTRADER_URL: string | null;
  AUTOLOGIN: 1 | 0;
}

const initialState: IPayments = {
  ALLOW_DEMO_ACCOUNTS: 0,
  ENABLE_PAYMENT: 0,
  ENABLE_CREDIT_CARD: 0,
  ENABLE_CREDIT_CARD_WITHDRAW: 0,
  ENABLE_BANK_CARD: 0,
  ENABLE_BANK_CARD_WITHDRAW: 0,
  ENABLE_WEB_TRADER: null,
  ENABLE_CRYPTO_PAY: 0,
  PAYMENT_CURRENCY: [],
  PAYMENT_CURRENCY_KASHA: [],
  PAYMENT_GATEWAYS: [],
  TRANSLATE: {},
  CRYPTO: {},
  // captcha
  ENABLE_RECAPTCHA: 0,
  RECAPTCHA_KEY: '',

  WEBTRADER_URL: null,
  AUTOLOGIN: 0,
};

const paymentsCurrency = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setPaymentsParameters(state, action) {
      state.ALLOW_DEMO_ACCOUNTS = action.payload.ALLOW_DEMO_ACCOUNTS;
      state.ENABLE_PAYMENT = action.payload.ENABLE_PAYMENT;
      state.ENABLE_CREDIT_CARD = action.payload.ENABLE_CREDIT_CARD;
      state.ENABLE_CREDIT_CARD_WITHDRAW = action.payload.ENABLE_CREDIT_CARD_WITHDRAW;
      state.ENABLE_BANK_CARD = action.payload.ENABLE_BANK_CARD;
      state.ENABLE_BANK_CARD_WITHDRAW = action.payload.ENABLE_BANK_CARD_WITHDRAW;
      state.PAYMENT_CURRENCY = action.payload.PAYMENT_CURRENCY;
      state.PAYMENT_GATEWAYS = action.payload.PAYMENT_GATEWAYS;
      state.ENABLE_WEB_TRADER = action.payload.ENABLE_WEB_TRADER;
      state.ENABLE_CRYPTO_PAY = action.payload.ENABLE_CRYPTO_PAY;
      state.TRANSLATE = action.payload.TRANSLATE;
      state.CRYPTO = action.payload.CRYPTO;
      // captcha
      state.ENABLE_RECAPTCHA = action.payload.ENABLE_RECAPTCHA;
      state.RECAPTCHA_KEY = action.payload.RECAPTCHA_KEY;

      state.WEBTRADER_URL = action.payload.WEBTRADER_URL;
      state.AUTOLOGIN = action.payload.AUTOLOGIN;
    },
    setPaymentsKashaCurrency(state, action) {
      state.PAYMENT_CURRENCY_KASHA = action.payload.PAYMENT_CURRENCY;
    },
    // setPaymentsMandatoCurrency(state, action) {
    //   state.PAYMENT_CURRENCY = action.payload.PAYMENT_CURRENCY
    // }
  },
});

const selectHasRecaptcha = (state: RootState) => state.payments.ENABLE_RECAPTCHA === 1;
const selectRecaptchaKey = (state: RootState) => state.payments.RECAPTCHA_KEY;
const selectWTUrl = (state: RootState) => state.payments.WEBTRADER_URL;
const selectIsCryptoPay = (state: RootState) => state.payments.ENABLE_CRYPTO_PAY;
const selectPaymentsCrypto = (state: RootState) => state.payments.CRYPTO;
const selectIsAutologin = (state: RootState) => state.payments.AUTOLOGIN === 1;

export {
  selectHasRecaptcha,
  selectRecaptchaKey,
  selectWTUrl,
  selectIsCryptoPay,
  selectPaymentsCrypto,
  selectIsAutologin,
};

export const { setPaymentsParameters, setPaymentsKashaCurrency } = paymentsCurrency.actions;
export default paymentsCurrency.reducer;
